import { Component, Input, SimpleChanges, Output, EventEmitter, OnChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { Playout } from '../../../interfaces/playout';
import { Embargo } from '../../../components/shared/bb-embargo/bb-embargo.component';

@Component({
	selector: 'mediaclip-details-embed',
	templateUrl: './mediaclip-details-embed.component.html',
	styleUrls: ['./mediaclip-details-embed.component.scss']
})


export class MediaclipDetailsEmbedComponent implements OnChanges {

	@Input() mediaclip: Mediaclip;
	@Input() form: NgForm;
	@Input() isActive: boolean;

	@Output() onPlayoutChange: EventEmitter<Playout>;

	embargo: Embargo;

	constructor() {
		this.onPlayoutChange = new EventEmitter<Playout>();
	}

	onPlayoutChanged(playout: Playout) {
		this.onPlayoutChange.emit(playout);
	}

	public publish(): void {
		if (this.mediaclip && this.mediaclip.status) {
			this.mediaclip.status = 'published';
			this.form.form.markAsDirty();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.mediaclip && this.mediaclip) {
			this.embargo = {
				embargoFrom: this.mediaclip.embargoFrom,
				embargoTo: this.mediaclip.embargoTo
			};
		}
	}

	onEmbargoChange(embargo: Embargo) {
		this.embargo = embargo;
		if (this.mediaclip && embargo) {
			this.mediaclip.embargoFrom = embargo.embargoFrom;
			this.mediaclip.embargoTo = embargo.embargoTo;
		}
		this.form.form.markAsDirty();
	}
}
